import { useTranslation } from 'react-i18next'
import { ProductCard } from '@/components/catalog'
import { publicProducts, type ContentLocale } from '@/data/public-catalog'
import { contentRoutes } from '@/i18n/content-routes'

export const pilotRelated = {
  'prd-emotrace-tracciabilita-sangue': ['prd-esapoct-gestione-poct', 'prd-samtrace-sistema-esamed-per-la-tracciabilita-delle-provette'],
  'prd-dc-2000-sl-stappatore': ['prd-tt-2000-s-endmed', 'prd-tt-2000-s-iqvision-endmed'],
  'prd-x12-pro-semen-analysis-system': ['prd-r10-bonraybio', 'prd-c-kup-bonraybio'],
} as const

export type PilotProductId = keyof typeof pilotRelated

export function RelatedProducts({ productId, language }: { productId: PilotProductId; language: ContentLocale }) {
  const { t } = useTranslation('common')
  return <section className="product-related catalog-section" aria-labelledby="related-title">
    <div className="shell-container">
      <div className="catalog-section-heading"><h2 id="related-title">{t('productPage.relatedTitle')}</h2></div>
      <div className="catalog-product-grid product-related-grid">
        {pilotRelated[productId].map(id => {
          const product = publicProducts.find(item => item.id === id)!
          const category = contentRoutes.find(item => item.id === product.categoryId)!
          return <ProductCard key={id} product={product} language={language} categoryPath={category[language]} />
        })}
      </div>
    </div>
  </section>
}
